const menuScreenflow = `
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
      <g fill="none" fill-rule="evenodd">
        <rect x="1" y="1" width="6" height="4.5" rx="0.5" stroke="#F5F5F5" stroke-linejoin="round"/>
        <rect x="6" y="6.75" width="6" height="4.5" rx="0.5" stroke="#F5F5F5" stroke-linejoin="round"/>
        <rect x="11" y="12.5" width="6" height="4.5" rx="0.5" stroke="#F5F5F5" stroke-linejoin="round"/>
        <path stroke="#F5F5F5" stroke-linejoin="round" d="M5.5 5.5 L7.5 6.75"/>
        <path stroke="#F5F5F5" stroke-linejoin="round" d="M10.5 11.25 L12.5 12.5"/>
        <rect width="18" height="18"/>
      </g>
    </svg>

`;

export default menuScreenflow;
